"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startServerActionRequest = startServerActionRequest;
exports.startSubmittingForm = startSubmittingForm;
exports.qaContextDI = qaContextDI;
exports.getQaHeader = getQaHeader;
exports.getQaAuthStateOverride = getQaAuthStateOverride;
exports.getQaParameter = getQaParameter;
function startServerActionRequest() {
  return function () {};
}
function startSubmittingForm() {
  return function () {};
}
function qaContextDI() {}
function getQaHeader() {
  return null;
}
function getQaAuthStateOverride() {
  return null;
}
function getQaParameter() {
  return null;
}